import { SocketIOEventEnum } from '@zaoblako/shared/common/enums/socketIO/socket.io.event.enum';
import { SocketIOEventTypeEnum } from '@zaoblako/shared/common/enums/socketIO/socket.io.event.type.enum';
import type { NetPingDeviceBarrierStatusInterface } from '@zaoblako/shared/modules/pacs/dtos/net-ping-device/net-ping-device-barrier-status.dto';
import type { AckResponseInterface } from '@zaoblako/shared/common/interfaces/ack.response.interface';
import type {
  ClientToServerEvents,
  ServerToClientEvents
} from '@zaoblako/shared/common/interfaces/socket.io.event.interface';

import { Injectable } from '@angular/core';
import { io, Socket } from 'socket.io-client';
import { Observable } from 'rxjs';

@Injectable() // IMPORTANT: Do not set `{ providedIn: 'root' }` here!
export class NetPingDeviceBarrierService {
  private socket: Socket<ServerToClientEvents, ClientToServerEvents> | undefined;

  /**
   * Connect to "NetPing" device socket
   *
   * @param authToken JWT for auth
   * @param deviceId Device unique ID
   */
  public init(authToken: string, deviceId: number) {
    this.socket = io(SocketIOEventTypeEnum.NET_PING_DEVICE, {
      path: '/api/socket/connect',
      timeout: 10 * 60 * 1000,
      auth: {
        token: authToken
      },
      withCredentials: true,
      query: {
        roomName: deviceId
      },
      multiplex: false
    });
  }

  /**
   * Disconnect from "NetPing" device
   */
  public destroy() {
    if (this.socket) {
      this.socket.disconnect();
      this.socket = undefined;
    }
  }

  /**
   * Get barrier status
   *
   * @returns `Observable` with status
   */
  public getBarrierStatus(): Observable<AckResponseInterface<NetPingDeviceBarrierStatusInterface>> {
    return new Observable((subscriber) => {
      if (!this.socket) {
        subscriber.error('Сокет не инициализирован. Сначала вызовите init().');
        return;
      }

      const sendEmit = () => {
        this.socket!.emit(SocketIOEventEnum.NET_PING_DEVICE_GET_BARRIER_STATUS, (response) => {
          subscriber.next(response);
          subscriber.complete();
        });
      };

      if (this.socket.connected) {
        sendEmit();
      } else {
        this.socket.once(SocketIOEventEnum.CONNECT, () => {
          sendEmit();
        });
      }

      // На случай, если компонент уничтожили во время ожидания ответа
      return () => {
        this.socket?.off(SocketIOEventEnum.CONNECT);
      };
    });
  }
}
